/* eslint-disable @typescript-eslint/naming-convention */
import { RenderingDetails } from "@swiggy-private/cart-types";
import { VALID_RENDERING_DETAILS_TYPE } from "@swiggy-private/cart-ui";

export const DEFAULT_WIDGET_SECTIONS: Omit<RenderingDetails, "children">[] = [
    {
        type: VALID_RENDERING_DETAILS_TYPE.MENU_ITEMS_ADDED_TO_CART,
        key: VALID_RENDERING_DETAILS_TYPE.MENU_ITEMS_ADDED_TO_CART,
        intermediateText: "",
        value: "",
        hierarchy: 1,
        display_text: "",
        info_text: "",
        icon: "",
        discount_message: "",
        currency: "",
    },
    {
        type: VALID_RENDERING_DETAILS_TYPE.CART_CROSS_SELL_ITEMS_SUGGESTION,
        key: VALID_RENDERING_DETAILS_TYPE.CART_CROSS_SELL_ITEMS_SUGGESTION,
        intermediateText: "",
        value: "",
        hierarchy: 1,
        display_text: "",
        info_text: "",
        icon: "",
        discount_message: "",
        currency: "",
    },
];
